export const API = {
  GET_USERS: {
    // Backend should accept pagination + optional filters in the body.
    // Payload includes: { productId?, page?, limit?, skip?, query? }
    path: '/auth/get-users-paginated',
    method: 'POST',
  },
};

